export function parallax() {
    let $window = $(window);
    let $parallax = $(".parallax");
    $window.on("load scroll", function () {
        let winTop = $window.scrollTop();
        $parallax.each(function () {
            let $this = $(this);
            let itemTop = $this.offset().top;
            let speed = $this.data("scroll-speed");
            if (winTop + $window.innerHeight() / 2 > itemTop && winTop + $window.innerHeight() / 2 < itemTop + $window.innerHeight() + $window.innerHeight() / 2) {
                $this.css('margin-top', Math.round(((winTop - itemTop) / speed)));
            }
        });
    });
}




// WEBPACK FOOTER //
// ./assets/js/modules/parallax.js